__turbopack_context__.v({
  "stepRealEstate": "styles-module-scss-module__tBQYFq__stepRealEstate",
});
